import {ToastrService} from 'ngx-toastr';
import {EcmService} from './../../../ecm.service';
import {CgpConfirmationDialogService} from './../../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import {UntypedFormControl, Validators} from '@angular/forms';
import {Component, Inject, OnInit} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {EcmNecReportsComponent} from '../ecm-nec-reports.component';

/**
 * Data that is sent to the dialog on start
 *
 * @interface EcmNecCompleteDateData
 */
interface EcmNecCompleteDateData {
  toolId: number;
  toolNo: string;
  necLec: string;
  necCompleteDate: string;
}

@Component({
  selector: 'ecm-nec-complete-date',
  templateUrl: './ecm-nec-complete-date.component.html',
})
export class EcmNecCompleteDateComponent implements OnInit {

  date: UntypedFormControl = new UntypedFormControl(null, Validators.required);
  necData: EcmNecCompleteDateData;

  constructor(
    private readonly dialogRef: MatDialogRef<EcmNecReportsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EcmNecCompleteDateData,
    private readonly confirmation: CgpConfirmationDialogService,
    private readonly service: EcmService,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit() {
    if (!this.validateDialogData()) {
      this.toastr.error('Invalid data sent to dialog');
      this.dialogRef.close();
      return;
    }

    this.necData = this.data;

    this.date.setValue(this.necData.necCompleteDate ? new Date(this.necData.necCompleteDate) : null);
  }

  /** CLASS FUNCTIONS */

  /**
   * Validate the data sent to the dialog
   *
   * @returns {boolean}
   * @memberof EcmNecCompleteDateComponent
   */
  validateDialogData(): boolean {
    return !!this.data.necLec && !!this.data.toolId;
  }

  /**
   * Update the NEC Complete Date for the current selection
   *
   * @memberof EcmNecCompleteDateComponent
   */
  updateNecCompleteDate() {
    this.service.updateEcmNecCompleteDate(
      this.necData.toolId,
      this.necData.necLec,
      this.date.value
    ).subscribe(
        () => {
            this.dialogRef.close(true);
        },
        () => {
            this.dialogRef.close(false);
        }
    );

    this.confirmation.closeConfirmationDialog();
  }

  /** UI FUNCTIONS */

  /**
   * Confirmation dialog to verify request to update ECM NEC Complete data
   *
   * @memberof EcmNecCompleteDateComponent
   */
  update(): void {
    this.confirmation.showConfirmationDialog({
      title: 'Update NEC Complete Date',
      message: 'Are you sure you want to update the NEC Complete Date?',
      onYesClick: this.updateNecCompleteDate.bind(this),
      onNoClick: this.confirmation.closeConfirmationDialog.bind(this.confirmation)
    });
  }
}
